import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../components/contexts/AuthContext";
import { AuthLayout } from "../../components/AuthLayout";
import { LoginForm } from "./LoginForm";

export function Login() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Redirect to intended page after login, or dashboard by default
  const from = location.state?.from?.pathname || "/dashboard";

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <AuthLayout
      kicker="Bienvenido de nuevo"
      title="Inicia sesión en Markezy"
      subtitle="Accede a tu cuenta para continuar."
      footer={<>¿Aún no tienes cuenta? <Link to="/registro">Crea tu cuenta gratis</Link></>}
    >
      <LoginForm />
    </AuthLayout>
  );
}
